import React from 'react';
import './JoinAcm.css';
import { FaBook, FaBriefcase, FaUsers, FaGlobe, FaCalendarAlt, FaLightbulb } from 'react-icons/fa';

const features = [
  {
    icon: <FaBook />,
    title: 'Access to Digital Library',
    text: 'Get unlimited access to a vast collection of articles, magazines, and conference proceedings.'
  },
  {
    icon: <FaBriefcase />,
    title: 'Career Development',
    text: 'Access exclusive job listings, career advice, and resources to advance your professional journey.'
  },
  {
    icon: <FaUsers />,
    title: 'Networking Opportunities',
    text: 'Connect with a global community of computing professionals and leaders in the field.'
  },
  {
    icon: <FaGlobe />,
    title: 'Global Community',
    text: 'Be a part of the world\'s largest educational and scientific computing society.'
  },
  {
    icon: <FaCalendarAlt />,
    title: 'Events & Webinars',
    text: 'Participate in local and international conferences, workshops, and webinars at a discount.'
  },
  {
    icon: <FaLightbulb />,
    title: 'Drive Innovation',
    text: 'Contribute to the future of technology by participating in our various initiatives and projects.'
  }
];

const JoinAcm = () => {
  return (
    <section className="join-acm-section">
      <h1 className="join-acm-title">Join ACM Today!</h1>
        <p className="join-acm-description">
            Become a member of the Association for Computing Machinery (ACM) and unlock a world of opportunities in computing.
            Whether you are a student, professional, or educator, ACM offers resources and support to help you thrive in your career.
        </p>
      <div className="features-grid">
        {features.map((feature, index) => (
          <div className="feature-card" key={index}>
            <div className="feature-icon">{feature.icon}</div>
            <h3 className="feature-title">{feature.title}</h3>
            <p className="feature-text">{feature.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default JoinAcm;